/** @file Converts premultiplied RGBA back to straight alpha in place (nearest rounding; alpha 0 stays black). */
import type { RgbaImage } from '@pose2d/math/types';
import { invariant } from '@pose2d/std/invariant';

/** Mutates `image` (or a band of it) from premultiplied to straight alpha and returns it. */
export function unpremultiply(image: RgbaImage): RgbaImage {
  invariant(image.premultiplied, 'unpremultiply: image is already straight alpha');
  const data = image.data;
  for (let i = 0; i < data.length; i += 4) {
    const a = data[i + 3] ?? 0;
    if (a === 255) continue;
    const half = a >> 1;
    // round(c * 255 / a) exactly (half-up); alpha 0 gives rgb 0.
    for (let k = 0; k < 3; k++) data[i + k] = a === 0 ? 0 : Math.floor(((data[i + k] ?? 0) * 255 + half) / a);
  }
  image.premultiplied = false;
  return image;
}
